<template>
  <div>
    detail
  </div>
</template>

<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'
export default {
  name: 'Detail',
  data () {
    return {
    }
  },
  methods: {
    getHomeInfo () {
      let vm = this
      axios.post('/app.php/Feedback/getFeedbacklist')
        .then(function (res) {
          res = res.data
          if (res.ret) {
            const data = res.data
            vm.routeList = data.routeList
            vm.number = data.number
            vm.handelRouteListChange(data.routeList[0]['id'])
          }
        })
      axios.post('/app.php/Basic/getJsApiSignpackage', {
        url: window.location.href
      }).then(function (res) {
        console.log('App.vue GetWxOAuth finish!')
        res = res.data
        if (res.ret) {
          console.log(1111)
          const data = res.data
          console.log(data)
          wx.config({
            debug: true,
            appId: data.signpackage.appid,
            timestamp: data.signpackage.timestamp,
            nonceStr: data.signpackage.noncestr,
            signature: data.signpackage.signature,
            jsApiList: ['scanQRCode']
          })
        }
      })
    },
    handelRouteListChange (routeId) {
      let vm = this
      axios.post('/app.php/Feedback/getFeedbacklist')
        .then(function (res) {
          res = res.data
          if (res.ret) {
            const data = res.data
            vm.ticketList = data.ticketList
          }
        })
    },
    wxscanQRCode () {
      alert(33333)
      // wx.scanQRCode({
      //   needResult: 0,
      //   scanType: ['qrCode', 'barCode'],
      //   success: function (res) {
      //     var result = res.resultStr
      //     console.log(result)
      //   }
      // })
      axios.post('/app.php/Example/wxpay')
        .then(function (res) {
          res = res.data
          if (res.ret) {
            const data = res.data
            wx.chooseWXPay({
              timestamp: data.timeStamp,
              nonceStr: data.nonceStr,
              package: data.package,
              signType: data.signType,
              paySign: data.paySign,
              success: function (res) {
                // 支付成功后的回调函数
                console.log(res)
              }
            })
          }
        })
    }
  },
  mounted () {
    // this.getHomeInfo()
  }
}
</script>

<style lang="stylus">
  body
    padding-bottom 1.2rem !important
</style>



// WEBPACK FOOTER //
// src/pages/demo/Detail.vue